<template>
    <loader v-if="loading" />
	<div v-else>
		<v-row>
			<v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts
                            height="400px"
                            type="line"
                            :options="avgEffectiveOptions"
                            :series="avgEffectiveSeries"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts
                            height="400px"
                            type="line"
                            :options="effectivePercentageOptions"
                            :series="effectivePercentageSeries"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts
                            height="400px"
                            type="line"
                            :options="agentCountOptions"
                            :series="agentCountSeries"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="team === 'Tryg' || team === 'Alka'">
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts
                            height="400px"
                            type="line"
                            :options="teamAgentCountOptions"
                            :series="teamAgentCountSeries"
                        />
                    </v-card-text>
                </v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
	},
	data() {
		return {
			loading: true,
			avgEffectiveSeries: [],
			avgEffectiveOptions: {
				title: {
					text: "Effektiv ringetid pr. agentur"
				}
			},
			avgActualSeries: [],
			effectivePercentageSeries: [],
			effectivePercentageOptions: {
				title: {
					text: "Effektiv andel"
				}
			},
			agentCountSeries: [],
			agentCountOptions: {
				title: {
					text: "Aktive agenturer"
				}
			},
			teamAgentCountSeries: [],
			teamAgentCountOptions: {
				title: {
					text: "Aktive agenturer pr. team"
				}
			},
			calls: null
		};
	},
	computed: {
		period() {
			return this.$store.state.development.period;
		},
		team() {
			return this.$store.state.main.team;
		},
		user() {
			return this.$store.state.development.user;
		},
		userSelect() {
			return this.$store.getters["development/userSelect"];
		},
		range() {
			return this.$store.state.development.range;
		},
		chartOptions() {
			return this.$store.state.development.chartOptions;
		},
		categories() {
			return this.$store.state.development.categories;
		},
		granularity() {
			return this.$store.state.development.granularity;
		},
		campaignSelect() {
			return this.$store.getters["development/campaignSelect"];
		},
		campaign() {
			return this.$store.state.development.campaign;
		},
        excludeWinback() {
            return this.$store.state.development.excludeWinback
        }
	},
	methods: {
		async getData() {
			this.loading = true;
			let settings =
				this.user +
				this.campaign +
				this.range.startDate +
				this.range.endDate +
                this.granularity;
            let team, department
            if (this.team === 'Alle teams') {
                team = null
            } else if (this.team === 'Tryg') {
                department = 'tryg'
            } else if (this.team === 'Alka') {
                department = 'alka'
            } else {
                team = this.team
            }
            const user = this.user === 'Alle agenturer' ? null : this.user
			let response = await this.$http().get("/development/efficiency",
				{
					params: {
						from: this.range.startDate,
						to: this.range.endDate,
                        team: team,
                        user: user,
                        department: department,
						granularity: this.granularity,
                        excludeWinback: this.excludeWinback
					}
				}
			);
			if (
				settings ===
				this.user +
					this.campaign +
					this.range.startDate +
					this.range.endDate +
					this.granularity
			) {
				this.avgEffectiveSeries = [
					response.data.series.avgEffectiveSeries,
					response.data.series.avgActualSeries
				];
				this.effectivePercentageSeries = [response.data.series.effectivePercentageSeries];
				this.agentCountSeries = [response.data.series.agentCountSeries];
			    this.teamAgentCountSeries = response.data.teamAgentCountSeries,
				this.$store.commit("development/setChartOptions", {
					formatter: this.$options.filters.duration,
					categories: response.data.labels
				});
				this.setAvgEffectiveOptions();
				this.setEffectivePercentageOptions();
				this.setAgentCountOptions();
				this.setTeamAgentCountOptions();
				this.loading = false;
			}
		},
		setAvgEffectiveOptions() {
			this.avgEffectiveOptions = {
				...this.chartOptions,
				colors: ['#00ff00', '#0000ff'],
				title: {
					text: "Effektivitet og arbejdstid"
				},
				legend: {
					position: "top"
				}
			};
		},
		setEffectivePercentageOptions() {
			this.effectivePercentageOptions = {
				...this.chartOptions,
				dataLabels: {
					enabled: true,
					formatter: this.$options.filters.percentage
				},
				colors: ["#ff0000"],
				title: {
					text: "Effektiv andel"
				},
                yaxis: {
                    labels: {
                        formatter: this.$options.filters.percentage
                    }
                }
			};
		},
		setAgentCountOptions() {
			this.agentCountOptions = {
				...this.chartOptions,
				dataLabels: {
					enabled: true,
					formatter: value => value
				},
				colors: ["#ff0000"],
				title: {
					text: "Aktive agenturer"
				}
			};
		},
		setTeamAgentCountOptions() {
			this.teamAgentCountOptions = {
				...this.chartOptions,
				dataLabels: {
					enabled: true,
					formatter: value => value
				},
				title: {
					text: "Aktive agenturer pr. team"
				},
				legend: {
					position: "top"
				}
			};
		}
	},
	watch: {
		userSelect: function() {
            if (!(this.userSelect.map(user => user.value)).includes(this.user)) this.$store.state.development.user = 'Alle agenturer'
			this.getData();
		},
		period: function(preset) {
			this.$store.commit("development/setRange", preset);
		},
		range: {
			handler() {
				this.getData();
			},
			deep: true
		},
		user: function() {
			this.getData();
		},
		campaign: function() {
			this.getData();
		},
		granularity: function() {
			this.getData();
		}
	},
	created() {
        this.$store.state.development.excludeWinback = false
        this.$store.state.development.tab = 'efficiency'
		if (this.userSelect.length > 1) {
			this.getData();
		}
	}
};
</script>